import { render, staticRenderFns } from "./BranchsList.vue?vue&type=template&id=d67faea8&scoped=true&"
import script from "./BranchsList.vue?vue&type=script&lang=js&"
export * from "./BranchsList.vue?vue&type=script&lang=js&"
import style0 from "./BranchsList.vue?vue&type=style&index=0&id=d67faea8&lang=scss&scoped=true&"
import style1 from "./BranchsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67faea8",
  null
  
)

export default component.exports